<template>
  <div id="content">
    <div class="content">
      <header class="header">
        <div class="header-content">
          <div class="logo">
            <h1>非凡小语种</h1>
            <img src="./assets/static/logo.png" alt="">
          </div>
          <div class="tab-list">
            <div class="tab-item" v-for="item in tabList" :key="item">{{item}}</div>
          </div>
        </div>
      </header>
      <div class="xyz-content">
        <Poster @submit="submit" @service="service" />
        <Consult @service="service" />
      </div>
      <FooterContent @submit="submit" />
      <div class="to-top" v-if="showTotop" @click="toTop()">
        <img src="./assets/static/totop.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import Poster from "./components/PosterInfo.vue"
import Consult from "./components/ConsultPage.vue"
import FooterContent from "./components/FooterContent.vue"
import axios from "axios"
import { tabList } from "./jsons/staticjson.js"
import { antiShake } from "./jsons/utils"
const BaseUrl = "http://www.weixue100.com/"

export default {
  name: 'App',
  components: {
    Poster,
    Consult,
    FooterContent,
  },
  data() {
    return {
      tabList,
      showTotop: true
    }
  },
  methods: {
    toTop() {
      this.showTotop = false
      document.querySelector("#content").scrollTop = 0
    },
    submit(param) {
      if (!param.name?.trim()) return this.$message.warning("请输入您的姓名")
      if (!param.phone?.trim()) return this.$message.warning("请输入您手机号")
      const myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
      if (!myreg.test(param.phone)) return this.$message.warning("您输入的手机号有误")
      param.content = param.content || ""
      param.type = 6
      const formData = new FormData()
      Object.keys(param).forEach(item => {
        formData.append(item, param[item])
      })
      axios.post(BaseUrl + "api/index.php?r=/v1/apply/form", formData).then(({ data }) => {
        if (data.result.status == 1) {
          this.$message.success("已预约成功")
        } else {
          this.$message.info(data.result.msg.phone.toString())
        }
      })
      console.log(window._agl);
      window._agl && window._agl.push(['track', ['success', { t: 3 }]])
    },
    service() {
      const doyoo_panel = document.getElementById("looyu_dom_1") // 内嵌客服
      doyoo_panel.click() // 调用客服代码
    }
  },
  mounted() {
    document.querySelector("#content").addEventListener("scroll", () => antiShake(() => {
      const appScrollTop = document.querySelector("#content").scrollTop
      if (appScrollTop > 1000) this.showTotop = true
      else this.showTotop = false
    }, 100)
    )
  }
}
</script>

<style scoped lang="scss">
#content {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
.content {
  width: 100%;
  min-height: 100%;
  background: url("./assets/static/bg.png") no-repeat center;
  background-size: 100% auto;
  background-color: #f3f6fb;
  .header {
    height: 80px;
    background-color: #e8354b;
    .header-content {
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      display: flex;
      align-items: center;
    }
    .logo {
      width: 180px;
      height: 42px;
      h1 {
        display: none;
      }
    }

    .tab-list {
      flex: 1;
      display: flex;
      padding-left: 74px;
      justify-content: flex-start;
      .tab-item {
        font-weight: 600;
        font-size: 20px;
        font-stretch: normal;
        color: #fff;
        width: 120px;
      }
    }
  }
  .xyz-content {
    margin: 0 auto;
    width: 1200px;
  }
  .to-top {
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    right: 60px;
    bottom: 200px;
    width: 60px;
    height: 60px;
    cursor: pointer;
    box-shadow: 1px 1px 1px 1px #e4e4e4;
    background-color: #fff;
    border-radius: 30px;
    img {
      height: 40px;
      width: 40px;
    }
  }
}
</style>
